import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/SHIV_logo5.png";
import Header from "./Header";
import {
  getUploadProfiles,
  doLogout,
} from "../redux/authSlice";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = localStorage.getItem("userName");
  const profile = useSelector((state) => state.auth.profile);

  const handleLogout = async () => {
    await dispatch(doLogout());
  };

  const handleProfile = async () => {
    navigate("/profile");
  }

  useEffect(() => {
    dispatch(getUploadProfiles());
  }, []);

  return (
    <header className="header">
      <div className="container">
        <div className="row top-menu-row">
          <div className="col-md-4 col-sm-12"></div>
          <div className="col-md-4 col-sm-12">
            <div className="logo admin-logo">
              <Link to={"/dashboard"}>
                <img src={logo} alt="Sunset in the mountains" />
              </Link>
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="right-user">
              <div className="right-user-3" onClick={handleProfile}>
                <img
                  src={profile.photoURL || "/profilePic.jpg"}
                  className="rounded-circle profile-img"
                  onError={({ currentTarget })=> {
                    if (currentTarget.src===profile.photoURL) currentTarget.src="/profilePic.jpg"
                  }}
                  height="30px"
                  alt=""
                  loading="lazy"
                />
                <div className="userName-btn">{userName.replace(/"/g, "")}</div>
              </div>

              <div className="logput-btn">
                <a onClick={handleLogout}> Logout </a>
              </div>
            </div>
          </div>
          <div className="crl"></div>
        </div>
        <div className="top-nav-bar">
          {" "}
          <Header />
        </div>
        <div className="crl"></div>
      </div>
      <div className="crl"></div>
    </header>
  );
};

export default Navbar;
